"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSendBroadcastRawPartnerMessageCtl = /** @class */ (function (_super) {
    __extends(DlgSendBroadcastRawPartnerMessageCtl, _super);
    function DlgSendBroadcastRawPartnerMessageCtl() {
        return _super.call(this, true) || this;
    }
    DlgSendBroadcastRawPartnerMessageCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            messageTitle: "",
            dialogTitle: "",
            messageText: "",
            visible: false,
            pprogramId: 0,
            pprogramTitle: "",
            pprogramsAvail: [],
            languageId: 0,
            languageTitle: "",
            languagesAvail: [],
            onNo: null
        };
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetMessageTitle = function (title, forceUpdate) {
        this.DATA.messageTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetMessageTitle = function () {
        return this.DATA.messageTitle;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetMessageText = function (body, forceUpdate) {
        this.DATA.messageText = body;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetMessageText = function () {
        return this.DATA.messageText;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetPPrograms = function (pprograms, forceUpdate) {
        this.DATA.pprogramsAvail = pprograms;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetPPrograms = function () {
        return this.DATA.pprogramsAvail;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetPProgramId = function (pprogramId, forceUpdate) {
        this.DATA.pprogramId = pprogramId;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetPProgramId = function () {
        return this.DATA.pprogramId;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetPProgramTitle = function (pprogramTitle, forceUpdate) {
        this.DATA.pprogramTitle = pprogramTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetPProgramTitle = function () {
        return this.DATA.pprogramTitle;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetLanguages = function (languages, forceUpdate) {
        this.DATA.languagesAvail = languages;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetLanguages = function () {
        return this.DATA.languagesAvail;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetLanguageId = function (languageId, forceUpdate) {
        this.DATA.languageId = languageId;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetLanguageId = function () {
        return this.DATA.languageId;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.SetLanguageTitle = function (languageTitle, forceUpdate) {
        this.DATA.languageTitle = languageTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSendBroadcastRawPartnerMessageCtl.prototype.GetLanguageTitle = function () {
        return this.DATA.languageTitle;
    };
    return DlgSendBroadcastRawPartnerMessageCtl;
}(BaseController_1.BaseController));
exports.DlgSendBroadcastRawPartnerMessageCtl = DlgSendBroadcastRawPartnerMessageCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSendBroadcastRawPartnerMessageCtl.ts
// module id = 904
// module chunks = 0